import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Checkbox, Collapse, FormControlLabel, FormGroup, List, ListItemButton, ListItemText, ListSubheader, Typography } from "@mui/material"
import { useEffect } from "react";
import { useReducer, useState } from "react";
import { MdClear } from "react-icons/md";

const TOGGLE_SECTION = 'TOGGLE_SECTION';
const RESET_ALL = 'RESET_ALL';
const UPDATE_SELECTED_FILTERS = 'UPDATE_SELECTED_FILTERS';

const initialState = {
    openSections: {
      country: false,
      leadSource: false,
      leadBranch: false,
      leadStatus: false,
      conversionStatus: false
    },
    selectedFilters: {
      country: [],
      leadSource: [],
      leadBranch: [],
      leadStatus: [],
      conversionStatus: []
    }
  };
  

const filterReducer = (state, action) => {
    switch (action.type) {
        case TOGGLE_SECTION:
            return {
                ...state,
                openSections: {
                    ...state.openSections,
                    [action.payload]: !state.openSections[action.payload]
                }
            };
        case RESET_ALL:
            return {
                ...state,
                openSections: Object.keys(state.openSections).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            };
        case UPDATE_SELECTED_FILTERS:
            const { sectionId, value, isSelected } = action.payload;
            let updatedValues;

            if (isSelected) {
                // Add the value if it's not already in the array
                updatedValues = [...state.selectedFilters[sectionId], value];
            } else {
                // Remove the value if it's in the array
                updatedValues = state.selectedFilters[sectionId].filter(item => item !== value);
            }

            return {
                ...state,
                selectedFilters: {
                    ...state.selectedFilters,
                    [sectionId]: updatedValues
                }
            }
        default:
            return state;
    }
};

const EnquiryFilter = (props) => {
    const { leadFilterFunction, data } = props

    const [state, dispatch] = useReducer(filterReducer, initialState);
    const [filterData, setFilterData] = useState({
        country: [],
        leadSource: [],
        leadBranch: [],
        leadStatus: [],
        conversionStatus: []
    });
    
    useEffect(() => {
        if (data && data.length > 0) {
            const extractUniqueFilterData = () => {
                const countries = new Set();
                const leadSources = new Set();
                const branches = new Set();
                const statuses = new Set();
                const conversionStatuses = new Set();

                data.forEach(item => {
                    if (item.livingCountry) {
                        countries.add(item.livingCountry);
                    }

                    if (item.leadSource) {
                        leadSources.add(item.leadSource);
                    }

                    if (item.branch_master && item.branch_master.branchName) {
                        branches.add(item.branch_master.branchName);
                    }

                    if (item.leadStatus) {
                        statuses.add(item.leadStatus);
                    }

                    if (item.conversionStatus) {
                        conversionStatuses.add(item.conversionStatus);
                    }
                });

                setFilterData({
                    country: Array.from(countries).filter(Boolean).sort(),
                    leadSource: Array.from(leadSources).filter(Boolean).sort(),
                    leadBranch: Array.from(branches).filter(Boolean).sort(),
                    leadStatus: Array.from(statuses).filter(Boolean).sort(),
                    conversionStatus: Array.from(conversionStatuses).filter(Boolean).sort()
                });
            };

            extractUniqueFilterData();
        }
    }, [data])

    useEffect(() => {
      leadFilterFunction(state.selectedFilters)
      }, [state.selectedFilters]);

    const toggleSection = (sectionId) => {
        dispatch({ type: TOGGLE_SECTION, payload: sectionId });
    };

    const handleClearClick = () => {
        dispatch({ type: RESET_ALL });
      };

    const handleCheckboxChange = (sectionId, value, isChecked) => {
        dispatch({
            type: UPDATE_SELECTED_FILTERS,
            payload: {
                sectionId,
                value,
                isSelected: isChecked
            }
        });
    };

    const filterSections = [
        {
          id: 'country',
          title: 'Country',
        },
        {
          id: 'leadSource',
          title: 'Lead Source',
        },
        {
          id: 'leadBranch',
          title: 'Lead Branch',
        },
        {
          id: 'leadStatus',
          title: 'Lead Status',
        },
        {
          id: 'conversionStatus',
          title: 'Conversion Status',
        }
      ];

    return (
        <>
        <List
          sx={{
            maxWidth: "316px",
            height: "auto",
            bgcolor: "background.paper",
            borderRadius: "8px",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            border: "1px solid #ECECEC",
            mt: 2.5,
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader
              component="div"
              id="nested-list-subheader"
              sx={{ backgroundColor: "#F2F2F2" }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>Filter</div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "12px",
                    cursor: "pointer",
                  }}
                  onClick={handleClearClick}
                >
                  <MdClear style={{ fontSize: "22px", height: "20px" }} />{" "}
                  <Typography>Clear All</Typography>
                </div>
              </div>
            </ListSubheader>
          }
        >
          {filterSections.map((section) => (
            <div key={section.id}>
              <ListItemButton onClick={() => toggleSection(section.id)}>
                <ListItemText primary={section.title} />
                {state.openSections[section.id] ? (
                  <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                ) : (
                  <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                )}
              </ListItemButton>
  
              <Collapse in={state.openSections[section.id]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton>
                    <FormGroup>
                      {filterData[section.id] && filterData[section.id].length > 0 ? (
                        filterData[section.id].map((item, index) => (
                          <FormControlLabel
                            key={`${section.id}-${index}`}
                            control={
                              <Checkbox
                                sx={{
                                  color: "#F8469A",
                                  "&.Mui-checked": {
                                    color: "#F8469A",
                                  },
                                }}
                                checked={state.selectedFilters[section.id].includes(item)}
                                onChange={(e) => handleCheckboxChange(section.id, item, e.target.checked)}
                              />
                            }
                            label={item}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No items to display
                        </Typography>
                      )}
                    </FormGroup>
                  </ListItemButton>
                </List>
              </Collapse>
            </div>
          ))}
        </List>
  
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            const inputValue = e.target.elements[0].value;
            //   props.handlePaginationEntry({ target: { value: inputValue } });
          }}
          sx={{
            display: "flex",
            gap: "10px",
            mt: "29px",
            alignItems: "center",
            "& input": {
              border: "1px solid #B8BECC",
              borderRadius: "4px",
              outline: "none",
              maxWidth: "80px",
              textAlign: "center",
              fontSize: "16px",
              lineHeight: "24px",
              padding: "5px 17px"
            }
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              lineHeight: "19px"
            }}
          >
            Showing Entries
          </Typography>
          <input
            type="number"
            defaultValue={10}
            //   defaultValue={props.pagiantionEntry}
            // onChange={(e) => props.handlePaginationEntry(e)}
          />
          <input type="submit" style={{ display: "none" }} />
        </Box>
      </>
    )
}

export default EnquiryFilter